import { Button, Skeleton, Stack, Typography } from '@mui/material';
import { DrawerHeader } from '../drawer/DrawerHeader';
import { DocumentType, graphql } from '../gql';
import { useApiQuery } from '../query/hooks';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { z } from 'zod';
import { OrderDashboardMetrics } from './OrderDashboardMetrics';
import { DrawerWrapper } from '../drawer/DrawerWrapper';
import { Add } from '@mui/icons-material';
import { useModalContext } from '../modal/ModalContext';

const dashboardMetrics = graphql(`
	query dashbord_sortedDashboardMetric {
		listDashboardMetric(orderBy: { order: asc }) {
			contentMetric {
				id
				metric {
					id
					name
				}
				activities {
					touchpoint {
						phase {
							journey {
								color
								id
								name
							}
						}
					}
				}
			}
			id
		}
	}
`);

const dashboard = graphql(`
	query dashboard_listDashboard {
		listDashboard {
			id
		}
	}
`);

export type OrderMetrics = NonNullable<DocumentType<typeof dashboardMetrics>>['listDashboardMetric'];

export const orderDashboardMetricsDrawerProps = z.object({});

export const OrderDashboardMetricsDrawer: FC = () => {
	const intl = useIntl();
	const { data, isLoading } = useApiQuery(dashboardMetrics);
	const { data: dashboardData } = useApiQuery(dashboard);
	const { setModal } = useModalContext();

	const metricsDataExist = data?.listDashboardMetric && data.listDashboardMetric.length > 0;

	return (
		<DrawerWrapper>
			<DrawerHeader
				menu={
					<Button variant={'outlined'} startIcon={<Add />} onClick={() => setModal({ type: 'addMetricToDashboard', maxWidth: 'xs' })}>
						<FormattedMessage id={'dashboard.metrics.add-metric'} />
					</Button>
				}
				title={intl.formatMessage({ id: 'dashboard.metrics.drawer.reorder.title' })}
			/>
			{!isLoading && metricsDataExist && (
				<>
					<Typography variant={'h4'} fontWeight={700}>
						<FormattedMessage id={'dashboard.metrics.drawer.reorder.perex'} />
					</Typography>
					<OrderDashboardMetrics
						dashboardMetrics={data.listDashboardMetric.map((metric) => metric).filter(Boolean)}
						dashboardId={dashboardData?.listDashboard[0].id ?? ''}
					/>
				</>
			)}

			{isLoading && (
				<Stack gap={1} width={'100%'}>
					<Skeleton variant={'rectangular'} height={50} width={'100%'} />
					<Skeleton variant={'rectangular'} height={50} width={'100%'} />
				</Stack>
			)}
		</DrawerWrapper>
	);
};
